class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener(
      'keyup',
      (evt) => evt.code === 'Escape' && this.close()
    );

    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;

    // Keep Shopify’s rendering untouched
    this.getSectionsToRender().forEach((section) => {
      const el = document.getElementById(section.id);

      if (!el) return;

      el.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();

    // Update free shipping AFTER render
    setTimeout(() => {
      fetch('/cart.js')
        .then((r) => r.json())
        .then((cart) => {
          if (typeof window.updateFreeShipping === 'function') {
            window.updateFreeShipping(cart);
          }
        })
        .catch(() => {});
    }, 50);
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;

    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');

      this.activeElement = disclosure
        ? disclosure.querySelector('summary')
        : null;

      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);

/* ======================================================
   FREE SHIPPING PROGRESS BAR (SAFE VERSION)
====================================================== */

window.updateFreeShipping = function (cart) {
  const root =
  document.querySelector('.cart-notification-product__content') ||
  document.querySelector('.cart-notification-product');
  if (!root) return;

  const threshold = 10000;
  const total = Number(cart.total_price || 0);

  const percent = Math.min(100, (total / threshold) * 100);
  const remaining = Math.max(0, threshold - total);

  // IMPORTANT: DO NOT replace Shopify product HTML
  let container = root.querySelector('.cart-notification-free-shipping');

  if (!container) {
    container = document.createElement('div');
    container.className = 'cart-notification-free-shipping';
   const anchor = root.querySelector('.cart-notification-product__content') || root;
anchor.appendChild(container);
  }

  container.innerHTML = `
    <div class="notif-message">
      ${
        percent >= 100
          ? `🎉 Free shipping unlocked!`
          : `You are $${(remaining / 100).toFixed(2)} away from free shipping`
      }
    </div>

    <div class="notif-progress">
      <div class="notif-bar" style="width:${percent}%"></div>
    </div>
  `;
};